import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  onFeedbackClick: () => void;
  onContactClick: () => void;
}

export default function Footer({ onFeedbackClick, onContactClick }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-4 md:py-6 px-0 md:px-4 border-t border-orange-500">
      <div className="max-w-3xl mx-auto flex flex-col items-center space-y-2 text-sm text-gray-400">
        <div className="flex items-center space-x-1">
          <span>Show Your Bits</span>
          <span>©</span>
          <span>{currentYear}</span>
        </div>
        <div className="flex items-center">
          <span>For Comedians, By Comedians</span>
        </div>
        <div className="flex space-x-4">
          <Link to="/privacy" className="hover:text-orange-500 transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-orange-500 transition-colors">Terms</Link>
          <button 
            onClick={onFeedbackClick}
            className="hover:text-orange-500 transition-colors"
          >
            Feedback
          </button>
          <button 
            onClick={onContactClick}
            className="hover:text-orange-500 transition-colors"
          >
            Contact Us
          </button>
        </div>
      </div>
    </footer>
  );
}
